









import { Vue, Component, Prop } from 'vue-property-decorator';
import { getTeacherSuffixInSession } from '../../utils/building_trans';

@Component({ components: {} })
export default class NoData extends Vue {
  get teacherSuffix() {
    return getTeacherSuffixInSession();
  }
}
